import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraSupportForNeurodiversitySecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M28.0321 27.5102C29.2878 27.5565 30.4421 27.686 31.502 27.8854C31.5905 27.8427 31.679 27.8011 31.7722 27.7643C33.1583 27.2075 34.8123 26.5367 36.3976 25.8897C35.3388 25.0278 34.1985 23.9735 33.5182 22.4278C32.1892 19.4064 35.0522 16.6425 40.5232 17.9865C38.3835 14.908 33.764 12.2594 23.7935 15.4387C5.88042 21.1527 11.6717 35.0004 19.6259 36.2137C18.5532 32.3398 20.2945 27.2253 28.0321 27.5102Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M35.7616 36.9121C36.2904 33.677 37.3807 32.2214 38.1506 30.8823C36.5607 29.5015 34.3837 28.4295 31.502 27.8857C27.6886 29.7508 28.2209 36.899 20.1781 36.2781C19.9929 36.2639 19.8088 36.2425 19.626 36.214C19.9882 37.5199 20.6696 38.6858 21.5502 39.4539C25.041 42.5039 31.523 40.2161 33.269 44.7904C35.015 49.3647 38.0061 49.9999 38.0061 49.9999C40.7492 49.5761 41.4411 47.4023 41.6356 44.3808C41.2244 44.3274 40.8039 44.2538 40.3753 44.1553C35.3889 43.012 35.7628 36.9121 35.7628 36.9121H35.7616Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M31.5035 27.8856C30.4436 27.6849 29.2893 27.5567 28.0337 27.5104C20.296 27.2255 18.5547 32.3412 19.6275 36.2139C19.8103 36.2424 19.9944 36.2637 20.1796 36.278C28.2223 36.8989 27.6889 29.7519 31.5035 27.8856Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M44.4882 19.506C43.052 18.7734 41.7253 18.2819 40.5233 17.9863C40.8657 18.4778 41.1441 18.9812 41.3712 19.4727C42.2949 21.4732 41.3759 23.8535 39.3632 24.6786C38.471 25.0443 37.4494 25.4622 36.3965 25.8908C37.8606 27.0839 39.1663 27.909 38.8775 29.1627C38.7319 29.7943 38.4675 30.3297 38.1495 30.883C40.7923 33.1791 41.8127 36.3299 41.7451 39.3276C41.7032 41.1488 41.7312 42.8714 41.6345 44.3816C46.0105 44.9455 49.3861 42.9462 51.0948 38.1843C52.9643 32.9749 52.4657 23.5722 44.4882 19.506Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M33.5168 22.4292C34.1971 23.9749 35.3374 25.0291 36.3962 25.8911C37.448 25.4625 38.4706 25.0446 39.3629 24.6789C41.3756 23.855 42.2946 21.4735 41.3709 19.473C41.1438 18.9815 40.8642 18.4781 40.523 17.9866C35.0509 16.6427 32.189 19.4065 33.518 22.428L33.5168 22.4292Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M38.1512 30.8818C37.3813 32.221 36.2922 33.6765 35.7622 36.9117C35.7622 36.9117 35.3883 43.0104 40.3747 44.1548C40.8034 44.2534 41.2239 44.327 41.635 44.3804C41.7317 42.8703 41.7049 41.1476 41.7457 39.3265C41.8144 36.3288 40.7941 33.1779 38.15 30.8818H38.1512Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
